import React, { useState } from 'react';
import { Settings2, X, Lock, RotateCcw } from 'lucide-react';

/**
 * Button that opens a modal to show/hide table columns.
 * Locked columns (identification/actions) are always visible.
 */
const ColumnSelector = ({ columns, visibleKeys, onToggle, onReset, label = 'Colunas' }) => {
  const [open, setOpen] = useState(false);

  const isVisible = (key) => visibleKeys.includes(key);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="btn-secondary flex items-center gap-2 text-sm"
        title="Configurar colunas visíveis"
        data-testid="column-selector-btn"
      >
        <Settings2 size={16} />
        {label}
      </button>

      {open && (
        <>
          <div className="modal-backdrop" onClick={() => setOpen(false)} />
          <div className="modal-content p-6 max-w-md">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-white">Colunas visíveis</h3>
              <button
                onClick={() => setOpen(false)}
                className="text-gray-400 hover:text-white"
                title="Fechar"
              >
                <X size={20} />
              </button>
            </div>
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {columns.map((col) => {
                const locked = Boolean(col.locked);
                return (
                  <label
                    key={col.key}
                    className={`flex items-center justify-between gap-3 p-2 rounded ${
                      locked ? 'bg-gray-800/40 opacity-80' : 'hover:bg-gray-800 cursor-pointer'
                    }`}
                  >
                    <span className="text-sm text-gray-200 flex items-center gap-2">
                      {locked && <Lock size={14} className="text-gray-500" />}
                      {col.label}
                      {locked && <span className="text-xs text-gray-500">(obrigatória)</span>}
                    </span>
                    <input
                      type="checkbox"
                      checked={isVisible(col.key)}
                      disabled={locked}
                      onChange={() => onToggle(col.key)}
                      className="accent-green-500"
                    />
                  </label>
                );
              })}
            </div>
            <div className="flex items-center justify-between mt-5">
              <button
                onClick={() => onReset()}
                className="btn-secondary flex items-center gap-2 text-sm"
                title="Restaurar colunas padrão"
                data-testid="column-reset-btn"
              >
                <RotateCcw size={16} />
                Restaurar padrão
              </button>
              <button onClick={() => setOpen(false)} className="btn-primary text-sm">
                Fechar
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ColumnSelector;